module.exports = "<div class=\"app-stepper\">\n  {{ 'REGISTER.STEP' | translate }} <span>{{ step }}/{{ range }} :</span>\n</div>"